<template>
  <div>
    <b-container class="about-us">
      <b-row>
        <b-col sm="12" class="mb">
          <h2 class="styled-title">Who We Are</h2>
        </b-col>
      </b-row>
      <b-row v-for="item in data" :key="item.id">
        <b-col cols="12" sm="8">
          <article class="inner-box mb">
            <div class="text">
              <div v-html="item.description"></div>
            </div>
            <div class="knowmore">
              <span>
                <router-link :to="item.route">
                  {{ item.buttonName }}
                  <b-icon icon="arrow-right"></b-icon>
                </router-link>
              </span>
            </div>
          </article>
        </b-col>
        <b-col cols="12" sm="4" class="icmspic text-center">
          <img :src="item.imageURL" alt="banking" width="300" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      data: []
    };
  },
  firestore: {
    data: db.collection("homeAbout")
  }
};
</script>

<style lang="scss" scoped>
.about-us {
  padding-top: 40px;
}
.icmspic {
  padding: 20px 0 0 0;
  height: 100%;
}
.icmsinfo {
  padding: 20px;
}
.icmsinfo .midtext {
  font-family: "Red Rose", cursive;
  font-size: 30px;
  color: #323232;
  line-height: 26px;
  margin: 0 0 12px 0;
}
.icmsinfo .bigtext {
  font-family: "Red Rose", cursive;
  font-size: 40px;
  color: #323232;
  line-height: 50px;
  margin: 0 0 20px 0;
}
.icmsinfo .smalltext {
  font-size: 20px;
  line-height: 24px;
  color: #323232;
  width: 95%;
}
.companyglance {
  margin: 50px 0 0 0;
}
.compglancetxt {
  font-size: 30px;
  color: #323232;
  font-family: "Red Rose", cursive;
}
.glancegroup {
  margin: 30px 0 0 0;
}
.glanceitem {
  display: inline-block;
  vertical-align: top;
  margin: 0 42px 0 0;
  padding: 0 42px 0 0;
  border-right: 1px solid #b0bec5;
}
.glancenumber {
  color: #af0000;
  font-size: 48px;
  font-family: "Red Rose", cursive;
}
.glancetxt {
  font-size: 14px;
  font-family: "Red Rose", cursive;
  text-transform: uppercase;
  color: #263238;
}
.glanceitem:last-child {
  border-right: 0;
  padding: 0;
  margin: 0;
}
</style>
